module.exports = __webpack_public_path__ + "media/images/icons/quote-7075fbbdffcd23b7e794f3196a416090.svg";